/** House-wide settings (module `house`) visible to this user, and the night-mode helper. */
import type { HomeModel, HouseSetting, ResolvedAccess } from '@home/shared';

/** House settings this user can see (needs at least `view` on the entity). */
export function visibleHouse(model: HomeModel | undefined, access: ResolvedAccess | undefined): HouseSetting[] {
  if (!model?.house || !access) return [];
  return model.house.filter((h) => model.entities[h.entityId] && access.entities[h.entityId]?.length);
}

/** The home's night-mode helper, if it has one and this user can see it. */
export function nightModeId(model: HomeModel | undefined, access: ResolvedAccess | undefined): string | null {
  return visibleHouse(model, access).find((x) => /\.night_mode$/.test(x.entityId))?.entityId ?? null;
}

/** Halloween "haunted house" helper (Woodlands; HA runs the lights and sounds, the app the tablets and doorbell). */
export const HAUNTED_ID = 'input_boolean.haunted_house';

/** The home's haunted-house helper, if it has one and this user can see it (by entity id, like nightModeId). */
export function hauntedId(model: HomeModel | undefined, access: ResolvedAccess | undefined): string | null {
  return visibleHouse(model, access).some((x) => x.entityId === HAUNTED_ID) ? HAUNTED_ID : null;
}
